module.exports = __webpack_public_path__ + "img/23400.8f08e5ef.jpg";